import { useCallback, useContext, useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";

import Geocoder from "leaflet-control-geocoder";
import "leaflet-control-geocoder/dist/Control.Geocoder.css";
import MapContext from "./MapContext";
import Icon from "./Icon";

export default function Geocordinate(props: any) {
  const map = useMap();

  const { setLatlng } = useContext(MapContext);

  let onDragEnd = useCallback(() => {
    return function (event: any) {
      const latlng = event.target.getLatLng();
      setLatlng(latlng.lat + "," + latlng.lng);
    };
  }, [setLatlng]);

  useEffect(() => {
    const GeocoderControl = new Geocoder({ defaultMarkGeocode: false });
    //GeocoderControl.addTo(map);
    GeocoderControl.on("markgeocode", function (e) {
      const latlng = e.geocode.center;
      const layer: any = e.geocode.html;
      L.marker(latlng, { icon: Icon, draggable: true })
        .addTo(map)
        .on("dragend", onDragEnd)
        .bindPopup(layer)
        .openPopup();
      map.fitBounds(e.geocode.bbox);
      setLatlng(latlng.lat + "," + latlng.lng);
    }).addTo(map);
  }, [map, onDragEnd, setLatlng]);

  return null;
}
